export const LEGEND_COLORS = {
  BLACK: '#080808',
  RANGE_LOW: '#EF5656',
  RANGE_MEDIUM: '#FFE7E5',
  RANGE_HIGH: 'transparent',
};
export const RUBRIC_COLORS = {
  CELL_1: '#FFB4B2',
  CELL_2: '#FFD9C5',
  CELL_3: '#FFE3CA',
  CELL_4: '#FFE9CD',
  CELL_5: '#FFF8D5',
  CELL_6: '#FAF2A9',
  CELL_7: '#F3F7D0',
  CELL_8: '#E2F0C5',
  CELL_9: '#CDE8B8',
  NULL: '#DDDDDD',
  CELL_DEFAULT: '#ACDBA2',
  CELL_TEXT_COLOR: '#080808',
  CELL_TEXT_COLOR_2: '#FFFFFF',
  CELL_NORMALIZE: '#FFE7E5',
  PROGRESS_BAR: '#006EB8',
};

export const AQUA_BASE = '#00758E';
export const RED_LIGHT = '#FFE7E5';
export const GREY_TEXT = '#686868';

export const STACKEDBARS_COLORS = {
  stronglyDisagree: '#721D39',
  disagree: '#B26487',
  neutral: '#949494',
  agree: '#3192D3',
  stronglyAgree: '#006EB8',
};
export const TOOLTIP_TEXT_COLOR = '#000000';
export const AXIS_TEXT_COLOR = '#757575';
